import React from 'react'
import { formatNumberWithIntl } from '../../../utils/formatNumber'
import { Spin } from 'antd'

export default function DashboardCard({ data }) {
	return (
		<Spin spinning={data.isLoading || false}>
			<div
				className={` bg-gray-100 drop-shadow-2xl p-2 rounded-xl w-full min-h-32 cursor-pointer hover:scale-[1.02]	transition-all duration-300 ease-in-out `}
				onClick={data.onNavigate || null}
			>
				<div className="flex gap-3 items-center justify-start mt-2">
					<div className={`bg-${data.iconBgColor} rounded-xl p-3`}>
						{data.icon}
					</div>
					<h2 className="text-xl font-bold">{data.title}</h2>
				</div>
				<div>
					<p
						className={`${data.priceColor || 'text-blue-900'} font-bold text-lg mt-5`}
					>
						{formatNumberWithIntl(data.price)}
					</p>
					{data.isRender && data.renderInner()}
				</div>
			</div>
		</Spin>
	)
}
